import React from 'react';
import { Input } from '@/components/ui/input';

export function emptyRoutingState() {
  return { extraTo: '', cc: '', bcc: '' };
}

/** Payload-Felder für POST extra_to / cc / bcc (leere Strings weglassen). */
export function routingApiPayload(state = {}) {
  const extra = (state.extraTo ?? state.extra_to ?? '').trim();
  const cc = (state.cc ?? '').trim();
  const bcc = (state.bcc ?? '').trim();
  return {
    ...(extra ? { extra_to: extra } : {}),
    ...(cc ? { cc } : {}),
    ...(bcc ? { bcc } : {}),
  };
}

/**
 * Zusätzliche Empfänger vor dem Versand: weitere An-Adressen, CC, BCC.
 * Werte werden beim Tippen übernommen (Safari: kein onBlur vor Speichern).
 */
export default function EmailRecipientFields({
  extraTo = '',
  cc = '',
  bcc = '',
  onChange,
  disabled = false,
  testId = 'email-routing',
}) {
  const patch = (key) => (e) => {
    onChange?.({ extraTo, cc, bcc, [key]: e.target.value });
  };

  return (
    <div className="grid gap-2 sm:grid-cols-3" data-testid={testId}>
      <label className="block text-xs">
        <span className="font-medium text-slate-500">Weitere Empfänger (An)</span>
        <Input
          type="text"
          value={extraTo}
          onChange={patch('extraTo')}
          disabled={disabled}
          placeholder="z. B. ich@schule.de"
          className="mt-1 h-8 text-sm"
          autoComplete="off"
          data-testid={`${testId}-extra-to`}
        />
      </label>
      <label className="block text-xs">
        <span className="font-medium text-slate-500">CC</span>
        <Input
          type="text"
          value={cc}
          onChange={patch('cc')}
          disabled={disabled}
          placeholder="Kopie, sichtbar"
          className="mt-1 h-8 text-sm"
          autoComplete="off"
          data-testid={`${testId}-cc`}
        />
      </label>
      <label className="block text-xs">
        <span className="font-medium text-slate-500">BCC</span>
        <Input
          type="text"
          value={bcc}
          onChange={patch('bcc')}
          disabled={disabled}
          placeholder="Kopie, verborgen"
          className="mt-1 h-8 text-sm"
          autoComplete="off"
          data-testid={`${testId}-bcc`}
        />
      </label>
      <p className="sm:col-span-3 text-[11px] text-slate-500">
        Mehrere Adressen mit Komma trennen. Weitere Empfänger und CC erscheinen in der Nachricht; BCC nur im Umschlag.
      </p>
    </div>
  );
}
